import React from 'react';
import { Grid } from '@material-ui/core';
import FormTextBox from './FormTextBox';
import FormAlongsideText from './FormAlongsideText';
import ICommonFormProps from '../interfaces/ICommonFormProps';

/**Smaller Textbox with text alongside,
 * by leaving off a second label the textbox will be bigger */
const FormSmallTextBox = (props: ICommonFormProps) => {
    return (
        <Grid container justify="center" alignItems="center" spacing={1}>
            <Grid item xs={props.formProps?.secondLabel ? 4 : 6}>
                <FormTextBox {...props} />
            </Grid>
            <Grid item xs={props.formProps?.secondLabel ? 8 : 6}>
                <FormAlongsideText
                    label={props.formProps?.sideLabel || ''}
                    secondLabel={props.formProps?.secondLabel}
                />
            </Grid>
        </Grid>
    );
};

export default FormSmallTextBox;
